import { IonText } from "@ionic/react";
import { ReactNode } from "react";

import ConditionalTooltip from "@components/ConditionalTooltip";
import styles from "@components/text/TextBlock.module.css";
import textSizeStyles from "@components/text/TextSizes.module.css";

type Props = {
  children: ReactNode;
  className?: string;
  hoverContent?: ReactNode;
  size?: "huge" | "large" | "normal" | "tiny";
};

const TextBlock = ({ children, className = "", hoverContent, size = "normal" }: Props) => (
  <ConditionalTooltip condition={!!hoverContent} content={hoverContent}>
    {tooltipTriggerProps => (
      <div className={styles.block} tabIndex={tooltipTriggerProps && 0} {...tooltipTriggerProps}>
        <IonText className={textSizeStyles[size] + " " + className}>{children}</IonText>
      </div>
    )}
  </ConditionalTooltip>
);

export default TextBlock;
